import { useParams, Navigate } from 'react-router-dom';

/**
 * Legacy URL /courses/:id/content redirects to the unified editor's Content tab.
 */
export default function CourseContentPage() {
    const { id } = useParams<{ id: string }>();
    return <Navigate to={`/courses/${id}/edit?tab=content`} replace />;
}
